import {
  ApplicationService,
  type ApplicationContractResponse,
  type ApplicationResponse,
} from '@acme/api';
import {
  combine,
  createEffect,
  createEvent,
  createStore,
  sample,
} from 'effector';

export const applicationOpened = createEvent<{ id: string }>();
export const applicationReset = createEvent();

const loadApplicationFx = createEffect(async ({ id }: { id: string }) => {
  const res = await ApplicationService.getApiV1Application({ id });
  if (!res.isSuccess || !res.data) {
    throw new Error(res.errorText || 'Не удалось загрузить заявку');
  }
  return res.data as ApplicationResponse;
});

const loadContractFx = createEffect(async ({ id }: { id: string }) => {
  const res = await ApplicationService.getApiV1ApplicationContract({ id });
  if (!res.isSuccess) {
    throw new Error(res.errorText || 'Не удалось загрузить контракт заявки');
  }
  return (res.data ?? null) as ApplicationContractResponse | null;
});

export const $application = createStore<ApplicationResponse | null>(null)
  .on(applicationReset, () => null)
  .on(loadApplicationFx.doneData, (_, data) => data);

export const $contract = createStore<ApplicationContractResponse | null>(null)
  .on(applicationReset, () => null)
  .on(loadContractFx.doneData, (_, data) => data);

export const $isLoading = combine(
  loadApplicationFx.pending,
  loadContractFx.pending,
  (a, b) => a || b
);

sample({
  clock: applicationOpened,
  target: [loadApplicationFx, loadContractFx],
});
